import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { AuthProvider } from "./hooks/AuthProvider";
import { ThemeProvider } from "./lib/ThemeProvider";
import { MOBILE_MAX, TABLET_MAX } from "./lib/breakpoints";
import { applyBranding } from "./lib/branding";
import { queryClient } from "./lib/queryClient";
import "./index.css";
import App from "./App.tsx";

// Titre, et kit de marque runtime si VITE_BRANDING_URL (D-DEMO-01) : avant le premier rendu.
applyBranding();

if (import.meta.env.PROD) {
  const viewportCategory = () => {
    const w = window.innerWidth;
    if (w <= MOBILE_MAX) return "mobile";
    if (w <= TABLET_MAX) return "tablet";
    return "desktop";
  };

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: "production",
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      /chrome-extension:/,
      /moz-extension:/,
      /^Network Error$/,
      /was released because another request stole it/,
    ],
    tracesSampleRate: 0.1,
    initialScope: { tags: { viewport_size: viewportCategory() } },
  });
}

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </QueryClientProvider>
);
